import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import {
  AccountPage,
  AuthCallbackPage,
  DemoPage,
  FamilyPage,
  FindPage,
  HomePage,
  LexbasePage,
  LoginPage,
  MonitorPage,
  RemovePage,
} from './pages/stubs';

/**
 * Route map (app.gdpr-nordic.org)
 * Auth flow:  /login /signup /otp /onboarding /demo
 * Shell:      / /find /remove /monitor /family /account
 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Auth / onboarding — no shell chrome */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/demo" element={<DemoPage />} />
        {/* /signup, /otp och /onboarding är borttagna.
            De var en attrapptratt: Signup tog e-post och LÖSENORD (inloggning
            sker med engångslänk — lösenord finns inte i systemet) utan att
            göra något nätverksanrop, Otp godkände vilken sexsiffrig kod som
            helst, och Onboarding simulerade en scan med setTimeout och visade
            sex påhittade exponeringar. En besökare kunde "skapa konto",
            "verifiera" och se resultat utan att något konto fanns.
            Registrering sker på /login — samma engångslänk skapar kontot. */}
        <Route path="/signup" element={<Navigate to="/login" replace />} />
        <Route path="/otp" element={<Navigate to="/login" replace />} />
        <Route path="/onboarding" element={<Navigate to="/find" replace />} />

        {/* Authenticated shell */}
        <Route element={<AppShell />}>
          <Route index element={<HomePage />} />
          <Route path="find" element={<FindPage />} />
          <Route path="remove" element={<RemovePage />} />
          <Route path="monitor" element={<MonitorPage />} />
          <Route path="family" element={<FamilyPage />} />
          <Route path="account" element={<AccountPage />} />
          <Route path="lexbase" element={<LexbasePage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
